import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toggleGuestUpgradeModal } from "redux/actions/app";
import styled from "styled-components";
import GreenCheckIcon from "web/assets/svg/GreenCheckMark"

const UpgradeGuestSubscription = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const accountType = localStorage.getItem('accountType')
  const approvalStatus = localStorage.getItem('approvalStatus')
  return (
    <Container>
      <div className="box-view">
        {/* <div></div> */}
        <div className="subscription">
          {/* className="profile-sec" */}
          <div>
            <div class="community-details-header seller">
              <div class="community-name d-flex w-100">
                <h4 className="flex-grow-1">Manage Subscription</h4>
                <button
                  className="upgrade-btn"
                  onClick={() => {
                    if(accountType === "Guest" && approvalStatus === "REQUEST_FOR_APPROVAL"){
                      dispatch(toggleGuestUpgradeModal(true))
                    }else{
                      // dispatch(toggleGuestUpgradeModal(true))
                      localStorage.setItem('guestUser', false);
                      localStorage.setItem('postInventory', true);
                      localStorage.setItem('memberShipType', 'buyerSeller');
                      localStorage.setItem('guestUserUpgrade', true);
                      history.push("/registration");
                    }
                  }}>{(accountType === "Guest" && approvalStatus === "REQUEST_FOR_APPROVAL") ? 'Pending Upgrade' : 'Upgrade Membership'}</button>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-sm-12">
               <h5 className="become-member-title">Become a Member and Access these Benefits</h5>
              </div>
              {/* <div className="col-sm-9">
                <h5>Current Benefits</h5> 
              </div>*/}
            </div>
            <div className="row mt-2">
              {/* <div className="col-sm-3"></div> */}
              <div className="col-sm-4">
                <ul>
                  <li>
                    <GreenCheckIcon /><span>Lower transaction fees</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>Ability to post out needs </span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>ACH payments</span>
                  </li>
                  {/* <li>
                    <GreenCheckIcon /><span>Explore Nearby Inventories</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>View Posted Inventories Details</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>Access Manage Account</span>
                  </li> */}
                </ul>
              </div>
              <div className="col-sm-5">
              <ul>
                  <li>
                  <GreenCheckIcon /><span>Transact privately with partners</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>Multi-location setup</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>Upload tax exemption forms</span>
                  </li>
                  {/* <li>
                  <GreenCheckIcon /><span>Access Notifications</span>
                  </li>
                  <li>
                  <GreenCheckIcon /><span>Recive Newsletter Emails</span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

const Container = styled.div`
        /* max-width: 1411px;
        padding: 15px 85px; */
        margin: 0 auto;
        .community-name{
          flex-wrap: wrap;
          align-items: center;
        }
        @media (max-width:1250px) {
            padding: 15px;
        }
        .box-view{
          /* display: grid;
          grid-template-columns: 237px 1fr;
          grid-column-gap: 46px;
          margin-top: 20px; */
          @media (max-width: 1250px) {
              grid-template-columns: 1fr;
            }
          @media (max-width:767px) {
              grid-template-columns: 1fr;
              .upgrade-btn{
                font-size: 16px;
              }
          }
          .subscription {
            display: flex;
            flex-direction: column;
          }
          .upgrade-btn{
            border-radius: 6px;
            background: #61b01f;
            background: -moz-linear-gradient(top,#61b01f 0%,#27911b 100%);
            background: -webkit-linear-gradient(top,#61b01f 0%,#27911b 100%);
            background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
            color: #fff;
            font-size: 20px;
            min-width: 200px;
            align-items: center;
            cursor: pointer;
            border: none;           
            padding:10px;
          }
          .community-details-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
          }
          .become-member-title{
            color: #43c9a3;
            font-size: 20px;
            font-weight: bold;
            text-align:left
          }
          h5{
            font-size: 20px;
            font-weight: bold
          }
          ul li {
            font-size: 15px;
            line-height: 2.5rem
          }
          ul li span{
            margin-left:5px
          }
        }
`

export default UpgradeGuestSubscription